import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SiteService } from '../../services/site.service';

@Component({
    selector: 'header',
    templateUrl: './header.component.html'
})
export class HeaderComponent {
    @Input() menus = [];
    openNav: boolean = false;
    currentPath: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private siteService: SiteService
    ) {
        // router.events.subscribe((event: Event) => {
        //     if (event instanceof NavigationEnd ) {
        //         this.currentPath = event.url;
        //     }
        // });
    }

    openNavMenu(): void {
        this.openNav = !this.openNav;
        const body = document.querySelector('body');
        if (body.classList.contains('overflow-hidden')) {
            body.classList.remove('overflow-hidden');
        } else {
            body.classList.add('overflow-hidden');
        }
    }

    moveUrl(path): void {
        const route = this.siteService.navigateMenu.find(p => p.label === path);
        const param = route.section ? {queryParams: { section: route.section }} : undefined;
        if (route) {
            this.router.navigate([route.path], param);
        }
    }

    getActiveMenu(menu): boolean {
        // let path = '/' + menu.path;
        // if (menu.section) {
        //     path += '?section=' + menu.section;
        // }
        // return path === this.currentPath;
        return false;
    }
}
